// Financial reporting excludes archived Lost jobs; source records remain untouched.
export function financialScope(jobs: any[]) {
  const lost = jobs.filter(job => job.pipeline_stage_name === 'Lost');
  const jobIds = new Set(lost.map(job => job.id));
  const estimateIds = new Set(lost.map(job => job.estimate_id).filter(Boolean));
  const leadIds = new Set(lost.map(job => job.lead_id).filter(Boolean));
  return {
    jobs: jobs.filter(job => !jobIds.has(job.id)),
    estimates: (rows: any[]) => rows.filter(row => !estimateIds.has(row.id) && !jobIds.has(row.job_id)),
    commissions: (rows: any[]) => rows.filter(row => !jobIds.has(row.job_id) && !leadIds.has(row.lead_id)),
  };
}
